import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const EditCancelModal = ({ show, onConfirm, onCancel }) => {
    return (
        <Modal show={show} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Cancelar cambios</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Estás seguro de que deseas cancelar los cambios sin guardarlos?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel} data-testid="edit-cancel-modal-keep-button">
                    No, mantener cambios
                </Button>
                <Button variant="primary" onClick={onConfirm} data-testid="edit-cancel-modal-confirm-button">
                    Sí, cancelar cambios
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditCancelModal;
